import { ReactNode } from "react";

import { twMerge } from "@krea/shared/design-system/tailwind-utils";

interface IDialogContentProps {
  children?: ReactNode;
  withLabel?: boolean;
  className?: string;
}

export const DialogContent = ({
  children,
  withLabel,
  className,
}: IDialogContentProps) => {
  return (
    <div
      className={twMerge(
        "tw-overflow-y-auto tw-grow-[1] tw-shrink-[1] tw-overflow-x-hidden",
        className,
      )}
    >
      <div
        className={twMerge("tw-px-6 tw-pb-6 tw-relative", {
          "tw-pt-8": withLabel,
          "tw-pt-4": !withLabel,
        })}
      >
        {children}
      </div>
    </div>
  );
};
